export default "__VITE_ASSET__3e1115c1__"